"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
function isScheduledEvent(object) {
    return checkScheduledEvent(object).fulfilled;
}
exports.isScheduledEvent = isScheduledEvent;
function checkScheduledEvent(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return __1.check(object, __1.hasString("id"), __1.hasString("name"), __1.hasNumber("scheduleDate"), __1.hasObject("payload")).withOptions(options).explain();
}
exports.checkScheduledEvent = checkScheduledEvent;
//# sourceMappingURL=ScheduledEvent.js.map